<form #editForm="ngForm">
  <div class="mct-flex mct-col mct-gap-27" *ngIf="formSettings">
    <div class="mct-flex mct-col mct-gap-18">
      <div class="sub-header">
        {{ 'form-builder.form-settings.profile-and-payment-label' | translate | ucfirst }}
      </div>
      <div *ngIf="descriptiveText">{{ descriptiveText }}</div>
      <div *ngIf="showLoginOptions" class="mct-flex mct-col mct-justify-center mct-items-start mct-gap-8">
        <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-radioButton
            [(ngModel)]="formSettings.LoginRequired"
            #loginRequired
            name="loginRequired"
            [value]="true"
            inputId="loginRequired"
          >
          </p-radioButton>
          <label for="loginRequired">
            {{ 'form-builder.form-settings.login-required' | translate | titlecase }}
          </label>
        </div>
        <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-radioButton
            [(ngModel)]="formSettings.LoginRequired"
            #loginOptional
            name="showLoginOptions"
            [value]="false"
            inputId="loginOptional"
          >
          </p-radioButton>
          <label for="loginOptional">
            {{ 'form-builder.form-settings.login-not-required' | translate | titlecase }}
          </label>
        </div>
        <div class="ml-15 mct-flex mct-col mct-justify-center mct-items-start mct-gap-8">
          <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
            <p-radioButton
              [disabled]="!!formSettings.LoginRequired"
              [(ngModel)]="formSettings.CreateNewProfile"
              #createProfile
              name="createProfile"
              [value]="true"
              inputId="createProfile"
            >
            </p-radioButton>
            <label for="createProfile">
              {{ 'form-builder.form-settings.create-profile' | translate | titlecase }}
            </label>
          </div>
          <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
            <p-radioButton
              [disabled]="!!formSettings.LoginRequired"
              [(ngModel)]="formSettings.CreateNewProfile"
              #createProfile
              name="createProfile"
              [value]="false"
              inputId="doNotCreateProfile"
              (onClick)="clearArbData()"
            >
            </p-radioButton>
            <label for="doNotCreateProfile">
              {{ 'form-builder.form-settings.do-not-create-profile' | translate | titlecase }}
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="showOrgIndFallthroughOptions" class="mct-flex mct-col mct-justify-center mct-items-start mct-gap-8">
        <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-radioButton
            [(ngModel)]="formSettings.ProfileLookupBehavior"
            #relatedIndProfile
            name="relatedIndProfile"
            [value]="profileLookupBehaviorEnum.RelatedIndMember"
            inputId="relatedIndProfile"
          >
          </p-radioButton>
          <label for="relatedIndProfile">
            {{ 'form-builder.form-settings.individual-membership' | translate | titlecase }}
          </label>
        </div>
        <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-radioButton
            [(ngModel)]="formSettings.ProfileLookupBehavior"
            #relatedOrgProfile
            name="relatedOrgProfile"
            [value]="profileLookupBehaviorEnum.RelatedOrgMember"
            inputId="relatedOrgProfile"
          >
          </p-radioButton>
          <label for="relatedOrgProfile">
            {{ 'form-builder.form-settings.organization-membership' | translate | titlecase }}
          </label>
        </div>
      </div>
    </div>
    <div class="mct-flex mct-col mct-gap-8" *ngIf="allowProfileBehavior">
      <div class="sub-header">
        {{ 'form-builder.form-settings.profile-lookup-behavior' | translate }}
      </div>
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
        <p-radioButton
          [(ngModel)]="formSettings.ProfileLookupBehavior"
          #authenticatedProfile
          name="authenticatedProfile"
          [value]="profileLookupBehaviorEnum.AuthenticatedProfile"
          inputId="authenticatedProfile"
        >
        </p-radioButton>
        <label for="authenticatedProfile">
          {{ 'form-builder.form-settings.authenticated-profile' | translate }}
        </label>
      </div>
      <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
        <p-radioButton
          [(ngModel)]="formSettings.ProfileLookupBehavior"
          #defaultLookupBehavior
          name="defaultLookupBehavior"
          [value]="profileLookupBehaviorEnum.Default"
          inputId="defaultLookupBehavior"
        >
        </p-radioButton>
        <label for="defaultLookupBehavior">
          {{ 'form-builder.form-settings.default-lookup-behavior' | translate }}
        </label>
      </div>
    </div>
    <ng-container *ngIf="isRenewalForm">
      <div class="mct-flex mct-col mct-gap-18">
        <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-checkbox
            #allowRejoinOnRenewalForms
            name="allowRejoinOnRenewalForms"
            [binary]="true"
            [(ngModel)]="formSettings.AllowRejoinOnRenewalForms"
            inputId="allowRejoinOnRenewalForms"
          >
          </p-checkbox>
          <label for="allowRejoinOnRenewalForms">
            {{ 'form-builder.form-settings.allow-rejoin-on-renewal-forms' | translate | ucfirst }}
          </label>
        </div>
        <div *ngIf="formSettings.AllowRejoinOnRenewalForms">
          <label>{{ 'form-builder.form-settings.renewal-rejoin-days-window' | translate | ucfirst }}</label>
          <input
            #renewalRejoinDaysWindow
            name="renewalRejoinDaysWindow"
            type="number"
            class="form-control"
            [(ngModel)]="formSettings.RenewalRejoinDaysWindow"
          />
        </div>
      </div>
      <div>
        <label>{{ 'form-builder.form-settings.renewable-profiles-dropdown-label' | translate | ucfirst }}</label>
        <input
          name="renewableProfileDropdownLabel"
          type="text"
          class="form-control"
          [(ngModel)]="formSettings.RenewableProfilesDropdownLabel"
        />
      </div>
    </ng-container>
    <div class="mct-flex mct-row mct-justify-between mct-items-start mct-gap-27" *ngIf="formSettings.FormPaymentOptions">
      <div class="mct-flex mct-col mct-gap-18 mct-basis-50">
        <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-checkbox
            #allowBillme
            name="allowBillme"
            [binary]="true"
            [(ngModel)]="formSettings.FormPaymentOptions.AllowBillMe"
            inputId="allowBillme"
          >
          </p-checkbox>
          <label for="allowBillme">
            {{ 'form-builder.form-settings.allow-billme-label' | translate | ucfirst }}
          </label>
        </div>
        <div>
          <label>{{ 'form-builder.form-settings.bill-me-text-label' | translate | ucfirst }}</label>
          <input
            #billMeText
            name="billMeText"
            type="text"
            class="form-control"
            [(ngModel)]="formSettings.FormPaymentOptions.BillMeText"
            [disabled]="!!!formSettings.FormPaymentOptions.AllowBillMe"
          />
        </div>
        <div></div>
      </div>
      <div class="mct-flex mct-col mct-gap-18 mct-basis-50">
        <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-checkbox
            #allowCreditCard
            name="allowCreditCard"
            [(ngModel)]="formSettings.FormPaymentOptions.AllowCreditCard"
            [binary]="true"
            inputId="allowCreditCard"
          >
          </p-checkbox>
          <label for="allowCreditCard">
            {{ 'form-builder.form-settings.allow-credit-card-label' | translate | ucfirst }}
          </label>
        </div>
        <div>
          <label>{{ 'form-builder.form-settings.credit-card-text-label' | translate | ucfirst }}</label>
          <input
            #creditCardText
            name="creditCardText"
            type="text"
            class="form-control"
            [(ngModel)]="formSettings.FormPaymentOptions.CreditCardText"
            [disabled]="!!!formSettings.FormPaymentOptions.AllowCreditCard"
          />
        </div>
        <div>
          <div class="arb-warning mb-5" *ngIf="!formSettings.CreateNewProfile && showLoginOptions">
            {{ 'form-builder.form-settings.arb-unavailable' | translate }}
          </div>
          <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
            <p-checkbox
              #allowArb
              name="allowArb"
              [(ngModel)]="formSettings.FormPaymentOptions.AllowArb"
              [binary]="true"
              [disabled]="!!!formSettings.FormPaymentOptions.AllowCreditCard || !formSettings.CreateNewProfile"
              inputId="allowArb"
            >
            </p-checkbox>
            <label for="allowArb">
              {{ 'form-builder.form-settings.allow-arb-label' | translate | ucfirst }}
            </label>
          </div>
        </div>
        <div>
          <label>{{ 'form-builder.form-settings.arb-text-label' | translate | ucfirst }}</label>
          <input
            #arbText
            name="arbText"
            type="text"
            class="form-control"
            [(ngModel)]="formSettings.FormPaymentOptions.ArbText"
            [disabled]="!!!formSettings.FormPaymentOptions.AllowCreditCard || !!!formSettings.FormPaymentOptions.AllowArb"
          />
        </div>
        <div *ngIf="formSettings.FormPaymentOptions.AllowArb" class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-checkbox
            #allowArb1
            name="allowArb1"
            [binary]="true"
            [(ngModel)]="formSettings.FormPaymentOptions.CreateInvoiceChargeOnSubmit"
            [disabled]="!!!formSettings.FormPaymentOptions.AllowCreditCard"
            inputId="allowArb1"
          >
          </p-checkbox>
          <label for="allowArb1">
            {{ 'form-builder.form-settings.invoice-and-charge' | translate | ucfirst }}
          </label>
        </div>
        <div *ngIf="formSettings.FormPaymentOptions.AllowArb">
          <p-select
            [placeholder]="'form-builder.form-settings.select-arb' | translate | ucfirst"
            #arbCycle
            name="arbCycle"
            [options]="revenueItemArbOptions"
            [(ngModel)]="formSettings.FormPaymentOptions.BillingCycle"
          ></p-select>
        </div>
        <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-checkbox
            #arbRequired
            name="arbRequired"
            [binary]="true"
            [(ngModel)]="formSettings.FormPaymentOptions.ArbRequired"
            [disabled]="!!!formSettings.FormPaymentOptions.AllowCreditCard || !!!formSettings.FormPaymentOptions.AllowArb"
            inputId="arbRequired"
          >
          </p-checkbox>
          <label for="arbRequired">
            {{ 'form-builder.form-settings.force-arb-label' | translate | ucfirst }}
          </label>
        </div>
        <div *ngIf="allowWriteOff" class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-8">
          <p-checkbox
            #writeOffOpenDues
            name="writeOffOpenDues"
            [binary]="true"
            [(ngModel)]="formSettings.FormPaymentOptions.WriteOffOpenDues"
            inputId="writeOffOpenDues"
          >
          </p-checkbox>
          <label for="writeOffOpenDues">
            {{ 'form-builder.form-settings.write-off-open-dues' | translate | ucfirst }}
          </label>
        </div>
        <div *ngIf="allowWriteOff">
          <p-select
            #writeOffAdjustmentTypeId
            name="writeOffAdjustmentTypeId"
            [disabled]="!formSettings.FormPaymentOptions?.WriteOffOpenDues"
            [options]="adjustmentTypeOptions"
            [(ngModel)]="formSettings.FormPaymentOptions.WriteOffAdjustmentTypeId"
            [placeholder]="'form-builder.form-settings.select-an-adjustment-type' | translate | ucfirst"
            appendTo="body"
            [style]="{ width: '100%' }"
          >
          </p-select>
        </div>
      </div>
    </div>
    <div class="mct-flex mct-col mct-gap-18 atlas-autocomplete">
      <label>{{ 'form-builder.form-settings.aff-code-label' | translate | ucfirst }}</label>
      <p-autocomplete
        #autoComplete
        name="affCodes"
        appendTo="body"
        field="AffCode"
        [suggestions]="searchAffCodesResults"
        [multiple]="true"
        (completeMethod)="searchAffCodes($event)"
        [(ngModel)]="formSettings.AffCodes"
        (onSelect)="updateApplyAffcode()"
        (onUnselect)="updateApplyAffcode()"
      >
        <ng-template let-item pTemplate="selectedItem">
          {{ item.AffCode }}
        </ng-template>
        <ng-template let-item pTemplate="item">
          {{ item.AffCode }}
        </ng-template>
      </p-autocomplete>
    </div>
    <hr />
    <div class="mct-flex mct-col mct-gap-18">
      <div class="sub-header">
        {{ 'form-builder.form-settings.email-settings-label' | translate | ucfirst }}
      </div>
      <div>
        <label>{{ 'form-builder.form-settings.email-recipients-label' | translate | ucfirst }}</label>
        <p-autocomplete
          #chips
          name="chips"
          appendTo="body"
          [addOnTab]="true"
          [addOnBlur]="true"
          seperator=","
          [multiple]="true"
          [typeahead]="false"
          [suggestions]="[]"
          (completeMethod)="primeChipCompleteMethod()"
          [(ngModel)]="formSettings.NotificationToEmail"
        >
        </p-autocomplete>
      </div>
      <div>
        <label>{{ 'form-builder.form-settings.confirmation-email-association-name-override-label' | translate | ucfirst }}</label>
        <input
          #confirmationEmailAssociationNameOverride
          name="confirmationEmailAssociationNameOverride"
          type="text"
          class="form-control"
          [(ngModel)]="formSettings.ConfirmationEmailAssociationNameOverride"
        />
      </div>
      <div *ngIf="showEditor">
        <label>{{ 'form-builder.form-settings.email-confirmation-label' | translate | ucfirst }}</label>
        <wl-wysiwyg-editor
          #emailMessage
          name="emailMessage"
          [editorName]="emailMessage"
          [showHtmlTemplates]="false"
          [disableImageSelector]="true"
          [emailContent]="true"
          [(ngModel)]="formSettings.ConfirmationEmailMessage"
        >
        </wl-wysiwyg-editor>
      </div>
    </div>
  </div>
</form>
